import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OutboundLink = props => {
  const { icon, text, href, type, underline } = props;
  let color = props.color,
    hoverColor = "hover-accent-dark";

  if (type == "light") {
    (color = "black-40"), (hoverColor = "hover-black-60");
  } else if (type == "faint-white") {
    (color = "white-70"), (hoverColor = "hover-white-90");
  } else if (type == "white") {
    (color = "white"), (hoverColor = "hover-white-90");
  } else if (type == "dark") {
    (color = "black-80"), (hoverColor = "hover-black-60");
  }

  const linkClasses = classnames([
    "link",
    { "underline-hover": !underline },
    { underline: underline },
    color,
    hoverColor
  ]);
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className={linkClasses}
      href={href}
      onClick={props.blurOnClick ? e => e.target.blur() : null}
    >
      {icon && (
        <FontAwesomeIcon className="mr1" icon={icon} transform="shrink-3" />
      )}
      {text}
    </a>
  );
};

OutboundLink.defaultProps = {
  icon: ["far", "external-link-alt"],
  color: "accent",
  underline: false,
  blurOnClick: false
};

OutboundLink.propTypes = {
  icon: PropTypes.array,
  text: PropTypes.string,
  href: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.oneOf(["light", "white", "faint-white", "dark"]),
  underline: PropTypes.bool,
  blurOnClick: PropTypes.bool
};

export default OutboundLink;
